import { CasePickupContactDto } from './case-pickup-contact.dto';
import { PackageDimensions } from './package-dimensions.dto';

/**
 * DTO to return the pickup information.
 */
export class CasePickupDto {
  public contact: CasePickupContactDto;
  public addressNotes?: string;
  public customerReference: string;
  public restrictedAccess: boolean;
  public tailLiftRequired: boolean;
  public pickupDate: Date;
  public totalPackageWeight: number;
  public singlePackageWeight: number;
  public weightUnit: string;
  public dimensions: PackageDimensions;
}
